const Logo = () => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return <img src="../assets/syGlassLogo_WhiteTransparent.png" alt="syGlass Logo" style={{width:'4rem', height:'2.9rem', display:'block', flexShrink:'0'}}/>
    } else {
        return <img src="../assets/syGlassLogo_Transparent.svg" alt="syGlass Logo" style={{width:'4rem', height:'2.9rem', display:'block', flexShrink:'0'}}/>;
    }
}

export default Logo;